"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = require("draft-js");
var editor_1 = require("@draft-js-plugins/editor");
var image_1 = __importDefault(require("@draft-js-plugins/image"));
var focus_1 = __importDefault(require("@draft-js-plugins/focus"));
var components_1 = require("./components");
function linkPluginStrategy(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            contentState.getEntity(entityKey).getType() === "LINK");
    }, callback);
}
function getContentEditorPlugins(readOnly) {
    var linkPlugin = {
        keyBindingFn: function (event, _a) {
            var getEditorState = _a.getEditorState;
            var editorState = getEditorState();
            var selection = editorState.getSelection();
            if (selection.isCollapsed()) {
                return;
            }
            if (draft_js_1.KeyBindingUtil.hasCommandModifier(event) && event.which === 75) {
                return "add-link";
            }
        },
        decorators: [
            {
                strategy: linkPluginStrategy,
                component: components_1.ContentEditorLink,
            },
        ],
    };
    var plugins = [linkPlugin];
    if (readOnly) {
        var imagePlugin = image_1.default();
        plugins = __spreadArrays(plugins, [imagePlugin]);
    }
    else {
        var focusPlugin = focus_1.default();
        var decorator = editor_1.composeDecorators(focusPlugin.decorator);
        var imagePlugin = image_1.default({ decorator: decorator });
        plugins = __spreadArrays(plugins, [focusPlugin, imagePlugin]);
    }
    return plugins;
}
exports.default = getContentEditorPlugins;
//# sourceMappingURL=plugins.js.map